import {IconSpeedCar} from "../../../../../components/buttons/IconButtons";
import {SPEED_UNIT_MODEL} from "../Model/Model";
import {getValueByKey} from "../../../../../Apis/functions";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const GeofenceCardSubtitle = ({backgroundColor, geofence}) => {
    const speedUnit = getValueByKey(geofence?.speedUnit, 'name', SPEED_UNIT_MODEL);

    return (
        <>
            <div className={`d-flex flex-column ${backgroundColor}`}>
                <div className='d-flex justify-content-between align-items-center w-100 mt-3'>
                    <div className='d-flex gap-2 align-items-center'>
                        <IconSpeedCar className='icon-color-shades-500' />
                        <span className='font-color-shades-500 ibl-font-w-500 fs-14px'>
                            {geofence?.speedLimit} {speedUnit}
                        </span>
                    </div>
                    <div className='d-flex gap-2 align-items-center'>
                        <IconSpeedCar className='icon-color-shades-500' />
                        <span className='font-color-shades-500 ibl-font-w-500 fs-14px'>
                            +{geofence?.speedTolerance} {speedUnit}
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
};
export default GeofenceCardSubtitle;
